import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useAuth } from '../contexts/AuthContext';
import { NOAH_MOODS, resolveMood, DEFAULT_EXPRESSION_MODE } from '../lib/noahMoods';

export const useNoahExpressionMode = () => {
  const { user } = useAuth();
  const mode = user?.noah_expression || DEFAULT_EXPRESSION_MODE;
  useEffect(() => { localStorage.setItem('deal_noah_expression', mode); }, [mode]);
  return mode;
};

export const NoahMascot = ({ mood = 'chat', size = 140, float = true, className = '', forceMood = false, testId }) => {
  const mode = useNoahExpressionMode();
  const key = forceMood ? mood : resolveMood(mood, mode);
  if (!key) return null;
  const pose = NOAH_MOODS[key] || NOAH_MOODS.chat;

  return (
    <motion.img
      src={pose.src}
      alt={pose.alt}
      data-testid={testId || `noah-mascot-${key}`}
      style={{ width: size, height: 'auto' }}
      className={`select-none pointer-events-none drop-shadow-xl ${className}`}
      initial={{ opacity: 0, y: 12, scale: 0.94 }}
      animate={float ? { opacity: 1, y: [0, -8, 0], scale: 1 } : { opacity: 1, y: 0, scale: 1 }}
      transition={float
        ? { opacity: { duration: 0.4 }, scale: { duration: 0.4 }, y: { duration: 4, repeat: Infinity, ease: 'easeInOut' } }
        : { duration: 0.4 }}
    />
  );
};

export default NoahMascot;
